import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';

import { GridOrchestrationDataAccess } from './orchestration/grid-orchestration-data-access';
import { GridOrchestrationService } from './orchestration/grid-orchestration.service';

/** Registers grid orchestration services. */
export function provideDeightonGrid(): EnvironmentProviders {
  return makeEnvironmentProviders([GridOrchestrationDataAccess, GridOrchestrationService]);
}
